var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39762",
    "data-name": "Path 39762",
    d: "M0,0H20V20H0Z",
    transform: "translate(-0.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_166503",
    "data-name": "Group 166503",
    transform: "translate(3.999 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39763",
    "data-name": "Path 39763",
    d: "M3,13.04V15.15a.344.344,0,0,0,.347.347H5.458a.326.326,0,0,0,.243-.1l7.582-7.575-2.6-2.6L3.1,12.79a.341.341,0,0,0-.1.25ZM15.3,5.8a.691.691,0,0,0,0-.979L13.672,3.2a.691.691,0,0,0-.979,0L11.422,4.471l2.6,2.6L15.3,5.8Z",
    transform: "translate(-3 -2.997)",
    fill: "#4169e1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b8dc36acd3d1840a5fa8c95b457a5ad7.svg";
export { ForwardRef as ReactComponent };